import styled from 'styled-components';

export const StyledYoutube = styled.div`
  .blog {
      min-height : 380px
  }
`;
